//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useEffect, useRef } from "react";
const TextField = (props: any) => {
  const { placeholder, value, register, type = "text", errors, label } = props;

  return (
    <>
      <div className={tw`w-full  text-left `}>
        <label htmlFor="">{label}</label>
        <input
          placeholder={placeholder}
          autoComplete="off"
          defaultValue={value}
          {...register}
          type={type}
          className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        />
        {errors && (
          <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
        )}
      </div>
    </>
  );
};

export default TextField;
